"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchCompanies = void 0;
var config_1 = require("../helpers/config");
var envConsts_1 = require("../helpers/envConsts");
var getQueryString_1 = require("../helpers/getQueryString");
var fetchWithToken_1 = require("../token/fetchWithToken");
var fetchCompanies = function (_a) {
    var projectId = _a.projectId, offset = _a.offset, limit = _a.limit;
    var query = (0, getQueryString_1.default)({ offset: offset, limit: limit });
    return (0, fetchWithToken_1.fetchWithToken)("".concat((0, config_1.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.ADMIN_API), "/v1/projects/").concat(projectId, "/companies").concat(query));
};
exports.fetchCompanies = fetchCompanies;
